import dayjs from 'dayjs'
import produce from 'immer'
import Actions from '../actions'
import { clinicTypes } from '../consts'
import {
  filterDMFollowUpAppointments,
  filterHTNFollowUpAppointments,
  filterMHFollowUpAppointments,
  filterPrimaryHmoFollowUpAppointments
} from '../utils/appointmentsUtils'

const initialState = {
  appointments: [],
  timeSlots: [],
  timeWindows: [],
  clinic: clinicTypes.PRIMARY,
  selectedTimeOption: null,
  eta: null,
  invitedMember: null,
  pendingAppointment: null,
  appointmentLocation: null,
  isAppointmentLoading: false,
  selectedAppointment: null,
  appointmentTimeLeft: null,
  designatedPk: null
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.DELETE_APPOINTMENT_RECEIVED: {
      draft.appointments = draft.appointments.filter(
        appointment => appointment.id !== payload.appointmentId
      )
      break
    }
    case Actions.APPOINTMENTS_POLL_RECEIVED: {
      const { eta, appointments } = payload
      draft.eta = eta
      draft.appointments = appointments
      draft.selectedAppointment = appointments.filter(
        appointment => appointment.id === draft.selectedAppointment?.id
      )[0]
      break
    }
    case Actions.CREATE_APPOINTMENT_RECEIVED: {
      draft.selectedAppointment = payload
      draft.isAppointmentLoading = false
      draft.appointments.push(payload)
      break
    }
    case Actions.APPOINTMENTS_ETA_RECEIVED: {
      const { eta } = payload
      draft.eta = eta
      break
    }
    case Actions.APPOINTMENT_TIME_SELECTED: {
      const { option, optionDisplayTime } = payload
      draft.selectedTimeOption = option
      draft.selectedTimeOptionDisplay = optionDisplayTime
      break
    }
    case Actions.CLEARED_APPOINTMENT_DESIGNATED_PK: {
      draft.designatedPk = null
      break
    }
    case Actions.APPOINTMENT_TIMEWINDOWS_RECEIVED: {
      draft.timeWindows = payload
      draft.designatedPk = null
      break
    }
    case Actions.CANCEL_APPOINTMENT_RECEIVED: {
      draft.appointments = draft.appointments.filter(
        appointment => appointment.id !== payload.appointmentId
      )
      break
    }
    case Actions.RESCHEDULE_APPOINTMENT_RECEIVED: {
      draft.appointments = draft.appointments.filter(
        appointment => appointment.id !== payload.appointmentId
      )
      break
    }
    case Actions.RESCHEDULE_APPOINTMENT_REQUESTED: {
      const { clinic, appointmentId } = payload
      draft.clinic = clinic
      draft.appointmentLocation = draft.appointments.find(
        appointment => appointment.id === appointmentId
      )?.appointment_location
      break
    }
    case Actions.APPOINTMENT_DESIGNATED_TIMEWINDOWS_RECEIVED: {
      const { timeWindows, designatedPk } = payload
      draft.timeWindows = timeWindows
      draft.designatedPk = designatedPk
      break
    }
    case Actions.SCHEDULE_ANY_PCP: {
      draft.designatedPk = null
      break
    }
    case Actions.CHOOSE_OTHER_MEMBER: {
      const { member } = payload
      draft.invitedMember = member
      break
    }
    case Actions.PENDING_APPOINTMENT_FOUND: {
      draft.pendingAppointment = payload
      break
    }
    case Actions.ACTIVATE_SLOT_TIMER: {
      const { expireTime, eta } = payload
      if (!draft.appointmentTimeLeft) {
        const now = dayjs().utc()
        draft.appointmentTimeLeft = eta
          ? now.add(eta, 'minutes')
          : dayjs(expireTime).utc()
      }
      break
    }
    case Actions.CREATE_APPOINTMENT_REQUESTED: {
      draft.isAppointmentLoading = true
      break
    }
    case Actions.CREATE_APPOINTMENT_FAILED: {
      draft.isAppointmentLoading = false
      break
    }
    case Actions.SELECTED_APPOINTMENT_CHANGED: {
      const appointment = payload
      draft.selectedAppointment = appointment
      break
    }
    case Actions.OPEN_DM_FOLLOW_UP_BOT_SCREEN: {
      draft.selectedAppointment = filterDMFollowUpAppointments(
        draft.appointments
      )?.[0]
      break
    }
    case Actions.OPEN_MH_FOLLOW_UP_BOT_SCREEN: {
      draft.selectedAppointment = filterMHFollowUpAppointments(
        draft.appointments
      )?.[0]
      break
    }
    case Actions.OPEN_HTN_FOLLOW_UP_BOT_SCREEN: {
      draft.selectedAppointment = filterHTNFollowUpAppointments(
        draft.appointments
      )?.[0]
      break
    }
    case Actions.OPEN_PRIMARY_HMO_FOLLOW_UP_BOT_SCREEN: {
      draft.selectedAppointment = filterPrimaryHmoFollowUpAppointments(
        draft.appointments
      )?.[0]
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    case Actions.SLOT_EXPIRED:
    case Actions.SLOT_CLEARED: {
      draft.appointmentTimeLeft = null
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
